"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.validation.providerRequired': 'Payment provider is required',
    'payment.validation.amountRequired': 'Valid amount is required',
    'payment.validation.currencyRequired': 'Currency is required',
};
